"use client";

import { NavigationPendingProvider } from "./NavigationPendingContext";
import UniversalNavigationIntent from "./UniversalNavigationIntent";
import type { ReactNode } from "react";

/** Wraps main chrome so mobile menu Links and sidebar Links share pending overlay context. */
export default function NavigationPendingRoot({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <NavigationPendingProvider>
      <UniversalNavigationIntent />
      {children}
    </NavigationPendingProvider>
  );
}
